import { uploadData } from "@aws-amplify/storage";

export const uploadImageToS3 = async (
  file: File,
  folder: string
): Promise<string> => {
  const fileName = `${folder}/${Date.now()}-${file.name}`;

  await uploadData({
    key: fileName,
    data: file,
    options: {
      accessLevel: "guest",
      contentType: file.type,
    },
  }).result;

  return fileName; // 👈 return the key instead of signed URL
};
